module.exports = __webpack_public_path__ + "img/pricets.25d41d17.svg";